<form role="form" class="form-inline cac-filters-form">
       	<div class="col-sm-2">
       		<label class="control-label">Agences&nbsp;:</label>
       	</div>
		<div class="col-sm-5">
			<checkbox-list 
				[id]="'choixAgence'"
				[wildcardOptionLabel]="'Tous'"
				[itemList]="agences"
				[labelGetter]="agenceLabelGetter"
				[preselectionFunction]="preselectAgenceByDefault"
				(selectedItemsChange) = "onAgenceChange($event)" >
			</checkbox-list>
		</div>

		<div class="form-group col-sm-4">
			<parc-filterable-selector
				[id]="'filtreParc'"
				[labelClass]="'col-md-2'"
				[fieldClass]="'col-md-8 plus-half'"
				(selectedParcIdChange)="onParcChange($event)" >
			</parc-filterable-selector>
		</div>
	
</form>